package com.loyola.acessoescola.ui.addnew

import acessoescola.composeapp.generated.resources.Res
import acessoescola.composeapp.generated.resources.add_a_photo_24px
import acessoescola.composeapp.generated.resources.add_facial
import acessoescola.composeapp.generated.resources.add_photo_alternate_24px
import acessoescola.composeapp.generated.resources.facial
import acessoescola.composeapp.generated.resources.select_image
import acessoescola.composeapp.generated.resources.take_photo
import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Card
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.LocalContentColor
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.ImageBitmap
import androidx.compose.ui.unit.dp
import com.bn.easymediapicker.core.MediaPickerConfig
import com.bn.easymediapicker.core.MediaPickerFactory
import com.bn.easymediapicker.core.MediaResult
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.launch
import org.jetbrains.compose.resources.stringResource
import org.jetbrains.compose.resources.vectorResource

@Composable
actual fun ImageField(
    onImagePick: (MediaResult?) -> Unit,
    photoBitmap: ImageBitmap?,
    isError: Boolean
) {
    val picker = MediaPickerFactory.create()
    val lifecycleScope = MainScope()

    Column(modifier = Modifier.padding(top = 8.dp)) {
        Card(modifier = Modifier.padding(bottom = 8.dp)) {
            Row(
                verticalAlignment = Alignment.CenterVertically,
                modifier = Modifier.fillMaxWidth().padding(horizontal = 4.dp)
            ) {
                Text(text=stringResource(Res.string.add_facial))
                Spacer(modifier = Modifier.weight(1f))
                IconButton(onClick = {

                    lifecycleScope.launch {
                        val image = picker.pickImage()
                        image?.let { result ->
                            onImagePick(result)
                        }
                    }
                }) {
                    Icon(
                        imageVector = vectorResource(Res.drawable.add_photo_alternate_24px),
                        contentDescription = stringResource(Res.string.select_image),
                        tint = if (isError) MaterialTheme.colorScheme.error else LocalContentColor.current
                    )
                }

                IconButton(onClick = {
                    lifecycleScope.launch {
                        val image = picker.captureImage(
                            config = MediaPickerConfig.Images
                        )
                        image?.let { result ->
                            onImagePick(result)
                        }
                    }

                }) {
                    Icon(
                        imageVector = vectorResource(Res.drawable.add_a_photo_24px),
                        contentDescription = stringResource(Res.string.take_photo),
                        tint = if (isError) MaterialTheme.colorScheme.error else LocalContentColor.current
                    )
                }
            }
        }
        Card{
            photoBitmap?.let { imageBitmap ->
                Image(
                    bitmap = imageBitmap,
                    contentDescription = stringResource(Res.string.facial)
                )
            }

        }
    }
}